var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShieldSecurity = function SvgShieldSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8.744 1.859 4.585 3.425c-.958.359-1.741 1.492-1.741 2.509v6.192c0 .983.65 2.274 1.441 2.866l3.584 2.675c1.175.883 3.108.883 4.283 0l3.583-2.675c.792-.592 1.442-1.883 1.442-2.867V5.935c0-1.025-.783-2.159-1.742-2.517L11.277 1.86c-.708-.259-1.842-.259-2.533 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M9.999 10.416a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333ZM10 10.417v2.5"
  })));
};
export default SvgShieldSecurity;